<template>
	<div style="margin: 1rem 0" v-if="assignees?.length">

		<div v-for="(element, index) in assignees" :key="element.id" style="display: flex; flex-wrap: nowrap; align-items: baseline; text-align: left; margin-bottom: 1rem;">		
			<div style="flex-basis: 1%">
			</div>
			<div style="flex-basis: 74px">		
			</div>

			<!-- assignee (employee/subscontractor) -->
			<div style="flex-basis: 18%">
				<div style="padding-left: 1.22rem;">
					<text v-if="!isSubcontract && element?.employee">
						{{ `${element?.employee!.lastname} ${(element?.employee?.firstname ?? '')} ${element?.employee!.lastname ?? ''}` }}
						<div>
							<el-text type="info" size="small">{{ element?.employee!.position!.name }}{{ (element?.employee!.positionGrade?.name ? `, ${element?.employee!.positionGrade?.name}` : '') }}</el-text>
						</div>
						<div v-if="!!element?.employee!.fireDate">
							<el-tag v-if="element?.employee!.fireDate" size="small" type="warning" effect="plain">Уволен</el-tag>
						</div>
					</text>

					<text v-if="isSubcontract">
						<counterparty-picker-component
							ref="counterpartyPicker"
							size="small"
							search-placeholder="Поиск подрядчиков по инициалам, телефону или email"
							:counterparty-type="counterpartyContractorType"
							@update:modelValue="onTableSubcontractorChange"
							v-model="element.subcontractor"
						/>
					</text>
				</div>
			</div>

			<!-- scheduled time -->
			<div style="flex-basis: 14%">
				<div style="padding-left: .4rem;">
					<div style="display: flex">
						<time-only-picker-component
							size="small"
							v-model="element.scheduledStartTime"
							@update:modelValue="onJobAssigneeTimeChanged"
							style="flex-basis: 46%"
						/>	
						<div style="flex-basis: 8%; text-align: center;">-</div>
						<time-only-picker-component
							size="small"
							v-model="element.scheduledEndTime"
							@update:modelValue="onJobAssigneeTimeChanged"
							style="flex-basis: 46%"
						/>
					</div>
					<el-link
						size="small" 
						type="primary" 
						:disabled="!element.scheduledStartTime && !element.scheduledEndTime" 
						:underline="false" 
						@click="(e) => onTableAssigneeTimeClearClick(element, e)"
					>
						очистить
					</el-link>
				</div>
			</div>
			
			<div style="flex-basis: 1%">
				&nbsp;
			</div>

			<!-- scheduled date -->
			<div>
				<date-only-picker-component
					size="small"
					v-model="element.scheduledDate"
					@update:modelValue="() => onJobAssigneeDateChanged(element)"
					style="min-width: 8rem; width: 9rem;"
				/>				
				<div>
					<el-link type="primary" :disabled="!element.scheduledDate" :underline="false" @click="(e) => onTableAssigneeDateClearClick(element, e)">очистить</el-link>
				</div>
			</div>


			<div style="flex-basis: 1%" v-if="!isSubcontract">
				&nbsp;
			</div>
			
			<!-- allocation percent -->
			<div style="flex-basis: 8%" v-if="!isSubcontract">
				<el-input-number 
					v-model="element.allocationPercent" 
					size="small"					
					:min="0"
					:max="100"
					@change="emitAssigneesUpdate"
				/>
			</div>

			<div style="flex-basis: 1%">
				&nbsp;
			</div>

			<!-- delete assignee button -->
			<div style="flex-basis: 8%">
				<el-button
					:icon="deleteIcon"
					circle
					size="small"
					@click="(e) => onTableDeleteAssigneeClick(index, e)"
				/>
			</div>
		</div>
	</div>

	<div style="margin: 1rem 0;" v-if="!assignees?.length">
		<div style="display: flex; flex-wrap: nowrap; align-items: baseline; padding-left: 1.22rem;">		
			<div style="flex-basis: 1%">
				&nbsp;
			</div>
			<div style="flex-basis: 74px">
				&nbsp;
			</div>
			<div>
				<el-text type="info">нет исполнителей ☹️</el-text>
			</div>			
		</div>
	</div>

	<div style="margin: 1rem 0;" v-if="!isSubcontract">
		<div style="display: flex; flex-wrap: nowrap; align-items: baseline; padding-left: 1.22rem;">		
			<div style="flex-basis: 1%">
				&nbsp;
			</div>
			<div style="flex-basis: 74px">
				&nbsp;
			</div>
			<div>
				<el-link 
					type="primary"
					size="small"
					:underline="false"
					@click="onTableAddAssigneeClick">
					добавить исполнителей
				</el-link>
			</div>
		</div>
	</div>
	
	<order-job-assignees-picker-modal-component 
		ref="assigneesPickerComponent"
		:default-branch-id="branchId"
		@assigned="onEmployeesAssigned"
	/>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Delete, } from '@element-plus/icons-vue';
import OrderJobViewModel from '@/ViewModels/OrderJobViewModel';
import OrderJobAssigneeModel from '@/models/OrderJobAssigneeModel';
import TableDraggableComponent from '@/components/TableDraggableComponent.vue'
import OrderJobAssigneesPickerModalComponent from './OrderJobAssigneesPickerModalComponent.vue';
import TimeOnlyPickerComponent from '../TimeOnlyPickerComponent.vue';
import DateOnlyPickerComponent from '../DateOnlyPickerComponent.vue';
import TimeOnlyRangePickerComponent from '../TimeOnlyRangePickerComponent.vue';
import OrderJobAssigneeViewModel from '@/ViewModels/OrderJobAssigneeViewModel';
import CounterpartyPickerComponent from '@/components/CounterpartyPickerComponent.vue';
import CounterpartyType from '@/models/enums/CounterpartyType';
import { watch, WatchStopHandle } from 'vue';

@Options({
	props: {
		modelValue: Array,
		job: Object,
		branchId: Number
	},	
	components: {
		CounterpartyPickerComponent,
		OrderJobAssigneesPickerModalComponent,
		TableDraggableComponent,
		TimeOnlyPickerComponent,
		DateOnlyPickerComponent,
		TimeOnlyRangePickerComponent
	},
	emits: ['update:modelValue']
})
export default class OrderJobAssigneesTableComponent extends Vue {
	/** props */
	job!: OrderJobViewModel;
	modelValue!: Array<OrderJobAssigneeModel>;	
	branchId!: number

	/** constants */
	deleteIcon = Delete;
	// define type for counterparties a registered as sub-contractors
	counterpartyContractorType = CounterpartyType.Contractor;

	/** view-models */
	isSubcontract = false;
	assignees: Array<OrderJobAssigneeViewModel> = [];

	watchSubcontractHandler: WatchStopHandle | null = null;
	watchAssigneesHandler: WatchStopHandle | null = null;

	mounted(): void {
		this.assignees = this.modelValue?.map(_ => new OrderJobAssigneeViewModel(_));
		this.isSubcontract = this.job?.isSubcontract ?? false;

		this.watchAssigneesHandler = watch(
			() => this.modelValue,
			() => this.assignees = this.modelValue?.length ? this.modelValue.map(_ => new OrderJobAssigneeViewModel(_)) : []
		);

		this.watchSubcontractHandler = watch(
			() => this.job,
			(v) => this.isSubcontract = v?.isSubcontract ?? false
		);
	}

	unmounted(): void {
		if (this.watchSubcontractHandler) {
			this.watchSubcontractHandler();
		}

		if (this.watchAssigneesHandler) {
			this.watchAssigneesHandler();
		}
	}

	emitAssigneesUpdate() {
		const assignees = this.assignees?.map(_ => new OrderJobAssigneeModel(_));
		this.$emit('update:modelValue', assignees);
	}
	
	onTableSubcontractorChange() {
		this.$nextTick()
			.then(() => this.emitAssigneesUpdate());
	}
	
	onTableAddAssigneeClick(e: Event) {
		e.stopPropagation();

		const assigneesPickerComponent = this.$refs.assigneesPickerComponent as OrderJobAssigneesPickerModalComponent;

		assigneesPickerComponent
			.setAssignees([])
			.show();
	}

	onTableDeleteAssigneeClick(assigneeIndex: number, e: Event) {
		e.stopPropagation();

		if (this.isSubcontract) {
			if (this.assignees.length == 1) {
				const subcontractAssignee = this.assignees[0];
				(this.$refs.counterpartyPicker as Array<CounterpartyPickerComponent>)[0].set();
				subcontractAssignee.subcontractor = null;
				subcontractAssignee.scheduledDate = null;
				subcontractAssignee.scheduledStartTime = null;
				subcontractAssignee.scheduledEndTime = null;
				subcontractAssignee.scheduledEndDate = null;
			} else {
				this.assignees.splice(assigneeIndex, 1);
			}
		} else {
			this.assignees.splice(assigneeIndex, 1);
			const allocationPercent = Math.floor((100 / this.assignees.length) * 100) / 100;
			this.assignees.forEach(_ => _.allocationPercent = allocationPercent);			
		}

		this.emitAssigneesUpdate();
	}

	/** fires when user adds/removes assignees for/from a job */
	onEmployeesAssigned(_orderJobVmId: number, assignees: Array<OrderJobAssigneeModel>) {	
		if (!this.assignees?.length) {
			this.assignees = [];
		}
		const allocationPercent = Math.floor(100 / assignees.length * 100) / 100;		
		assignees.forEach(a => {
			a.allocationPercent = allocationPercent;
			this.assignees.push(new OrderJobAssigneeViewModel(a));
		});

		this.emitAssigneesUpdate();
	}

	/** fires when user clears assigneed date */
	onTableAssigneeDateClearClick(assignee: OrderJobAssigneeViewModel, e: Event) {
		e.stopPropagation();
		assignee.scheduledDate = null;		
		assignee.scheduledEndDate = null;		
		this.emitAssigneesUpdate();
	}

	/** fires when user clears assignee's time range */
	onTableAssigneeTimeClearClick(assignee: OrderJobAssigneeViewModel, e: Event) {
		e.stopPropagation();
		assignee.scheduledStartTime = null;
		assignee.scheduledEndTime = null;
		this.emitAssigneesUpdate();
	}

	formatJobScheduledStartDate(job: OrderJobViewModel) {
		const jobAssignees = job.assignees;
		if (!jobAssignees?.length) {
			return '';
		}

		const sortedAssigneesArray = jobAssignees.sort(_ => _.assigneeOrder);
		const firstAssignee = sortedAssigneesArray[0];

		if (!firstAssignee.scheduledDate ||
			!firstAssignee.scheduledStartTime) {
			return '';
		}

		return `${this.formatDateOnly(firstAssignee.scheduledDate!)}, ${this.formatTimeOnly(firstAssignee.scheduledStartTime)}`; 
	}

	formatJobScheduledEndDate(job: OrderJobViewModel) {
		const jobAssignees = job.assignees;
		if (!jobAssignees?.length) {
			return '';
		}

		const sortedAssigneesArray = jobAssignees.sort(_ => _.assigneeOrder);
		const lastAssignee = sortedAssigneesArray[sortedAssigneesArray.length - 1];

		if (!lastAssignee.scheduledDate ||
			!lastAssignee.scheduledStartTime) {
			return '';
		}

		return `${this.formatDateOnly(lastAssignee.scheduledDate!)}, ${this.formatTimeOnly(lastAssignee.scheduledStartTime)}`; 
	}

	/** fires when user changes assignee's scheduled TIME manually via time-picker */
	onJobAssigneeTimeChanged() {		
		this.emitAssigneesUpdate();
	}

	/** fires when user changes assignee's scheduled DATE manually via date-picker */
	onJobAssigneeDateChanged(assignee: OrderJobAssigneeViewModel) {			
		assignee.scheduledEndDate = assignee.scheduledDate;
		this.emitAssigneesUpdate();
	}

	/** formats TimeOnly: 10:30 */
	formatTimeOnly(startTime?: string, endTime?: string) {	

		if (!startTime || !endTime) {
			return '';
		}

		const [sh, sm] = startTime.split(':').map(Number);	
		const startTimeOnly = `${sh < 10 ? '0' + sh : sh}:${sm < 10 ? '0' + sm : sm}`;
		
		const [she, sme] = endTime.split(':').map(Number);	
		const endTimeOnly = `${she < 10 ? '0' + she : she}:${sme < 10 ? '0' + sme : sme}`;

		return `${startTimeOnly} - ${endTimeOnly}`;
	}

	/** formats DateOnly to long date: 1 января 2025? */
	formatDateOnly(dateOnly: string) {
		if (!dateOnly?.length) {
			return '';
		}

		const [year, month, day] = dateOnly.split('-').map(Number);		
		const nowYear = new Date().getFullYear();
		let fullMonth = '';
		switch(month) {
			case 1: fullMonth = 'января'; 	break;			
			case 2: fullMonth = 'февраля'; 	break;
			case 3: fullMonth = 'марта'; 	break;
			case 4: fullMonth = 'апреля'; 	break;
			case 5: fullMonth = 'мая'; 		break;
			case 6: fullMonth = 'июня'; 	break;
			case 7: fullMonth = 'июля'; 	break;
			case 8: fullMonth = 'августа'; 	break;
			case 9: fullMonth = 'сентября'; break;
			case 10: fullMonth = 'октября'; break;
			case 11: fullMonth = 'ноября'; 	break;
			case 12: fullMonth = 'декабря';	break;
		}

		return `${day} ${fullMonth}${year == nowYear ? '' : ` ${year}`}`;
	}
}
</script>

<style>
	.order-jobs-table {

	}

		.order-jobs-table tr {
			cursor: pointer;
		}

			.order-jobs-table tr.active-row {
				background: var(--el-color-primary-light-9);
			}

		.order-jobs-table tr:hover:not(.active-row) {
			background: var(--el-color-info-light-9);
		}		

	.order-jobs-assignees-table {
		border: 1px solid var(--el-color-primary);
		border-radius: var(--el-border-radius-base);
		margin-top: 1.4rem;
	}
</style>